import type {
  Ability,
  CharacterStats,
  MovementStats,
} from '../../CharacterTypes';

export const HUNTER_CONFIG = {
  name: 'Wayfinder',
  description: 'Agile ranged combatant with high mobility and precision',
  baseStats: {
    strength: 11,
    dexterity: 16,
    intelligence: 10,
    luck: 9,
    attack: 16,
    magicAttack: 0,
    defense: 8,
    magicDefense: 10,
    criticalRate: 0.15
  } as CharacterStats,
  healthMultiplier: 0.9,
  manaMultiplier: 0.9,
  color: '#228B22',
  movementStats: {
    jumpPower: 1100,
    targetJumpHeight: 200,
    moveSpeed: 320,
    gravityScale: 0.9,
    terminalVelocity: 700,
    acceleration: 2200,
    deceleration: 1800
  } as MovementStats,
  abilities: [
    {
      id: 'ranger_auto',
      name: 'Quick Shot',
      damage: 10,
      manaCost: 0,
      cooldown: 600,
      lastUsed: 0,
      range: 550,
      castTime: 0,
      description: 'Basic arrow shot.',
      icon: '/icons/quick_shot.svg'
    },
    {
      id: 'quick_shot',
      name: 'Quick Shot',
      damage: 12,
      manaCost: 0,
      cooldown: 500,
      lastUsed: 0,
      range: 600,
      castTime: 0,
      description: 'Fire a quick arrow',
      icon: '/icons/quick_shot.svg'
    },
    {
      id: 'spread_shot',
      name: 'Spread Shot',
      damage: 12,
      manaCost: 15,
      cooldown: 3000,
      lastUsed: 0,
      range: 500,
      castTime: 0,
      description: 'Fire 3 arrows in a spread',
      icon: '/icons/spread_shot.svg'
    },
    {
      id: 'hunters_mark',
      name: 'Hunter\'s Mark',
      damage: 0,
      manaCost: 12,
      cooldown: 12000,
      lastUsed: 0,
      range: 400,
      castTime: 0,
      description: 'Mark target for increased damage',
      icon: '/icons/hunters_mark.svg'
    },
    {
      id: 'volley',
      name: 'Volley',
      damage: 22,
      manaCost: 20,
      cooldown: 15000,
      lastUsed: 0,
      range: 300,
      castTime: 2000,
      description: 'Rain of arrows on target area',
      icon: '/icons/volley.svg'
    },
    {
      id: 'swift_escape',
      name: 'Swift Escape',
      damage: 0,
      manaCost: 15,
      cooldown: 20000,
      lastUsed: 0,
      range: 0,
      castTime: 0,
      description: 'Increase movement speed for 8 seconds',
      icon: '/icons/swift_escape.svg'
    }
  ] as Ability[]
};
